import { render } from "./Drawings.vue?vue&type=template&id=60a5c54a"
import script from "./Drawings.vue?vue&type=script&lang=js"
export * from "./Drawings.vue?vue&type=script&lang=js"

import "./Drawings.vue?vue&type=style&index=0&id=60a5c54a&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__